/* global Modernizr:false */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { scrollToPosition } from 'app/utils/helpers';
import { dlTrackBackToTopClick } from 'app/analytics/productListAnalytics';
import { isUserTabbing, getFocusableElements } from 'app/utils/accessibility/accessibilityUtils';
import { BACK_TO_TOP_DURATION } from '../productList/productListConstants';
import './back-to-top.scss';

const BackToTop = ({ visible, duration, intl }) => {
  function scrollToTop(event) {
    event.preventDefault();
    scrollToPosition(0, duration);
    dlTrackBackToTopClick();
    document.activeElement.blur();
    if (isUserTabbing()) {
      getFocusableElements(document.getElementById('main'))[0].focus();
    }
  }

  const classes = ['back-to-top-btn'];

  if (Modernizr.touch) {
    classes.push('touch');
  }

  if (visible) {
    classes.push('back-to-top-btn--visible');
  }

  return (
    <button
      aria-label={intl.formatMessage({ id: 'back.to.top' })}
      type="button"
      className={classes.join(' ')}
      onClick={scrollToTop}
    >
      <span className="back-to-top-btn__icon icon-back-to-top" />
    </button>
  );
};

BackToTop.propTypes = {
  visible: PropTypes.bool,
  duration: PropTypes.number,
};

BackToTop.defaultProps = {
  duration: BACK_TO_TOP_DURATION,
  visible: false,
};

export default injectIntl(BackToTop);
